// data/items/quivers.js
// Ranged back slot items - 4 tiers unlocked via quests
// Can be repurchased from shop after quest completion

// Quiver tier definitions
const QUIVER_TIERS = {
    1: {
        id: 'leather_quiver',
        name: 'Leather Quiver',
        color: '#8B4513',
        rangedAccuracy: 12,
        speedBonus: 3,  // % attack speed increase
        ammoEfficiency: 5,  // % chance to not consume arrow
        combatLevel: 30,
        questId: 'quiver_leather',  // Quest ID for unlock
        shopPrice: 500,
        value: 0  // Cannot be sold
    },
    2: {
        id: 'ironwood_quiver',
        name: 'Ironwood Quiver',
        color: '#654321',
        rangedAccuracy: 22,
        speedBonus: 5,
        ammoEfficiency: 10,
        combatLevel: 45,
        questId: 'quiver_ironwood',
        shopPrice: 2000,
        value: 0
    },
    3: {
        id: 'ashen_quiver',
        name: 'Ashen Quiver',
        color: '#4a4a4a',
        rangedAccuracy: 35,
        speedBonus: 8,
        ammoEfficiency: 15,
        combatLevel: 60,
        questId: 'quiver_ashen',
        shopPrice: 8000,
        value: 0
    },
    4: {
        id: 'veilstalker_quiver',
        name: 'Veilstalker Quiver',
        color: '#6b2d7b',
        rangedAccuracy: 50,
        speedBonus: 12,
        ammoEfficiency: 20,
        combatLevel: 75,
        questId: 'quiver_veilstalker',
        shopPrice: 25000,
        value: 0
    }
};

// Generate quiver items
function generateQuivers() {
    const quivers = [];

    for (let tier = 1; tier <= 4; tier++) {
        const tierData = QUIVER_TIERS[tier];

        quivers.push({
            id: tierData.id,
            name: tierData.name,
            color: tierData.color,
            tier: tier,
            slot: 'back',
            backType: 'quiver',  // For style validation
            rangedAccuracy: tierData.rangedAccuracy,
            speedBonus: tierData.speedBonus,  // % reduction in attack interval
            ammoEfficiency: tierData.ammoEfficiency,  // % chance to save ammo
            combatLevel: tierData.combatLevel,
            // Quest unlock
            questId: tierData.questId,
            questLocked: true,  // Requires quest completion to obtain
            shopPrice: tierData.shopPrice,  // Rebuy price after unlock
            value: tierData.value  // 0 = cannot be sold
        });
    }

    return quivers;
}

export const QUIVERS = generateQuivers();

// Helper to get quiver by tier
export function getQuiverByTier(tier) {
    return QUIVERS.find(q => q.tier === tier);
}

// Helper to check if quiver is unlocked (for shop display)
export function isQuiverUnlocked(quiverId, completedQuests = []) {
    const quiver = QUIVERS.find(q => q.id === quiverId);
    if (!quiver) return false;
    return completedQuests.includes(quiver.questId);
}

// Export tier info
export { QUIVER_TIERS };

export default QUIVERS;
